import 'bootstrap/dist/css/bootstrap.css';
const siglaAssets = window.config.SIGLA_ASSETS;
if (siglaAssets != undefined && siglaAssets == 'eixosp') {
  const nowUi = () => import('../assets/scss/now-ui-kit-eixo.scss');
  nowUi();
} else if (siglaAssets != undefined && siglaAssets == 'rs') {
  const nowUi = () => import('../assets/scss/now-ui-kit-rs.scss');
  nowUi();
} else if (siglaAssets != undefined && siglaAssets == 'ecorodovias') {
  const nowUi = () => import('../assets/scss/now-ui-kit-ecorodovias.scss');
  nowUi();
} else if (siglaAssets != undefined && siglaAssets == 'default') {
  const nowUi = () => import('../assets/scss/now-ui-kit-default.scss');
  nowUi(); 
} else if (siglaAssets != undefined && siglaAssets == 'epr') {
  const nowUi = () => import('../assets/scss/now-ui-kit-epr.scss');
  nowUi(); 
} else if (siglaAssets != undefined && siglaAssets == 'antt') {
  const nowUi = () => import('../assets/scss/now-ui-kit-antt.scss');
  nowUi(); 
} else {
  const nowUi = () => import('../assets/scss/now-ui-kit.scss');
  nowUi();
}

import globalDirectives from './globalDirectives';
import globalMixins from './globalMixins';
import globalComponents from './globalComponents';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import VueLazyload from 'vue-lazyload';

locale.use(lang);

export default {
  install(Vue) {
    Vue.use(globalDirectives);
    Vue.use(globalMixins);
    Vue.use(globalComponents);
    Vue.use(VueLazyload, {
      observer: true,
      // optional
      observerOptions: {
        rootMargin: '0px',
        threshold: 0.1
      }
    });
  }
};
